import { render, staticRenderFns } from "./LoginVerify.vue?vue&type=template&id=6b810995&scoped=true"
import script from "./LoginVerify.vue?vue&type=script&lang=ts"
export * from "./LoginVerify.vue?vue&type=script&lang=ts"
import style0 from "./LoginVerify.vue?vue&type=style&index=0&id=6b810995&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b810995",
  null
  
)

export default component.exports